import { Map } from 'immutable';
import { isEqual, omit } from 'lodash';

export enum FavoriteType {
    Tournament = 'tournament',
    Match = 'match',
    MarketGlobal = 'tlv-market-global'
}

export enum GlobalFavMarketOperation {
    Save = 'save',
    Delete = 'delete'
}

export type Favorite = OverviewMatchFavorite | OverviewTournamentFavorite | DetailMarketFavorite;

export interface OverviewTournamentFavorite extends Map<string, string> {
    sportCode: string;
    sportId: string;
    tournamentId: string;
}

export interface OverviewMatchFavorite extends Map<string, string> {
    sportCode: string;
    sportId: string;
    tournamentId: string;
    id: string;
    expirationTime: string;
}

export interface DetailMarketFavorite extends Map<string, string> {
    marketId: string;
    matchId: string;
}

export function isFavoriteEqual(left: Favorite, right: Favorite): boolean {
    return isEqual(omit(left, ['expirationTime', 'sportCode']), omit(right, 'expirationTime', 'sportCode'));
}
